common.View.create('website::layouts.main.Slider', {

	onDOMLoad()
	{
		this.initSlider();
	},

	initSlider()
	{
        if( this.element.find('.slider').children().length <= 1 ) {
            return;
        }

        this.element.find('.slider')
            .owlCarousel({
                center: true,
                items: 1,
                loop: false, // this.element.find('.slider').children().length > 1
                autoplay: this.element.data('autoplay'),
                autoplayTimeout: 7500,
                autoplayHoverPause: this.element.data('autoplay'),
                autoplaySpeed: 1000,
            });
	},

});
